<template>
  <v-dialog max-width="600px">
    <v-btn flat slot="activator" class="sucess">PM Operation</v-btn>
    <v-card>
      <v-title>
        <h2>PM Operation</h2>
      </v-title>
    </v-card>
  </v-dialog>
</template>

<script>
export default {};
</script>
